import { render, staticRenderFns } from "./DbpyES.vue?vue&type=template&id=056a433a"
import script from "./DbpyES.vue?vue&type=script&lang=js"
export * from "./DbpyES.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports